import type { FaireProductEntity } from "../../entity_types/product";

export const p_m8a3syb77h: FaireProductEntity = {
  token: "p_m8a3syb77h",
  type: "product",
  name: "Gold CZ Enamel Evil Eye Adjustable Ring, Sku#Y861",
  brandToken: "b_4f46qpq5wu",
  brandName: "BestBeads&Beyond",
  imageUrl:
    "https://cdn.faire.com/fastly/cbf6dc3b23b14b8e5d9419a717ecfe505a2ac5c7aa5c0249bb3c79a6615ebf8c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23d41370d3e3246836c54b048090478e98bf09d1b94d84a3ebc4b236db739b62.jpeg",
    "https://cdn.faire.com/fastly/e5e7ccbd3d657c395cf0b679ab858057fa0ae93bbeb2e51718cea68f1d7cf39c.jpeg",
    "https://cdn.faire.com/fastly/1756d419c31a272c61360ac54dfec102b219db25c4339469ea17798ef2a02652.jpeg",
  ],
  priceDollars: 7.02,
  description:
    "\nQty:1pc pack\nMaterial: Gold filled \n\n\n\nSilver: Rhodium Plated\nGold: 14K Gold Filled\nBlack: Palladium Plated\nRose Gold: Palladium Plated over Copper\nUsage: Gold Filled findings have a precious metal look. Ready to wear.\n--------------------------------------------------\nShip from the U.S.A in 1-2 business days.\n\n* Lead-Free & Cadmium Free & Nickel Free*\n\n*All sizes are approximate\n\n***Please Conv. me if you need quantity discount. \n",
  tags: [],
  msrpDollars: 14.04,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:00.194Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
